/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineService
 */

export const AgentConfigChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.AgentConfigChirpContentBlock';
export const ContextChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ContextChirpContentBlock';
export const DisplayOnlyChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.DisplayOnlyChirpContentBlock';
export const FileChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.FileChirpContentBlock';
export const ImageChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ImageChirpContentBlock';
export const ImageToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ImageToolResultChirpContentBlock';
export const PdfChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.PdfChirpContentBlock';
export const PendingToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.PendingToolResultChirpContentBlock';
export const RedactedThinkingChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.RedactedThinkingChirpContentBlock';
export const ServerToolUseChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ServerToolUseChirpContentBlock';
export const TextChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.TextChirpContentBlock';
export const ThinkingChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ThinkingChirpContentBlock';
export const ToolApprovalRequestChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolApprovalRequestChirpContentBlock';
export const ToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolResultChirpContentBlock';
export const ToolUseChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolUseChirpContentBlock';

/**
 *  Identifies the turn that will process a successful steer.
 *  <p>The effective turn is the requested turn when it accepted the steer, or a newly queued
 *  follow-up turn when the requested turn was already terminal.
 */

export const AppSearchScopeContextTypename = 'com.hubspot.breeze.engine.shared.models.context.AppSearchScopeContext';
export const BreezeAssistantTrackingContextTypename = 'com.hubspot.breeze.engine.shared.models.context.BreezeAssistantTrackingContext';
export const CrmObjectContextTypename = 'com.hubspot.breeze.engine.shared.models.context.CrmObjectContext';
export const DeviceContextTypename = 'com.hubspot.breeze.engine.shared.models.context.DeviceContext';
export const FileReferencesContextTypename = 'com.hubspot.breeze.engine.shared.models.context.FileReferencesContext';
export const InteractiveModeContextTypename = 'com.hubspot.breeze.engine.shared.models.context.InteractiveModeContext';
export const ModelOverrideContextTypename = 'com.hubspot.breeze.engine.shared.models.context.ModelOverrideContext';
export const PageContextTypename = 'com.hubspot.breeze.engine.shared.models.context.PageContext';
export const PortalSkillsContextTypename = 'com.hubspot.breeze.engine.shared.models.context.PortalSkillsContext';
export const SkillsContextTypename = 'com.hubspot.breeze.engine.shared.models.context.SkillsContext';
export const SubAgentExecutionContextTypename = 'com.hubspot.breeze.engine.shared.models.context.SubAgentExecutionContext';
export const SubagentConfigContextTypename = 'com.hubspot.breeze.engine.shared.models.context.SubagentConfigContext';
export const TimeZoneContextTypename = 'com.hubspot.breeze.engine.shared.models.context.TimeZoneContext';
export const ToolSetCustomizationsContextTypename = 'com.hubspot.breeze.engine.shared.models.context.ToolSetCustomizationsContext';
export const ViewedArtifactContextTypename = 'com.hubspot.breeze.engine.shared.models.context.ViewedArtifactContext';
export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const sendMessageRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'sendMessage',
  auth: 'app',
  fingerprint: 'BCxl_42erSVxd9wdwHrhIUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendMessagesRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'sendMessages',
  auth: 'app',
  fingerprint: '2R4SlzDwQ-Vxd9wdwHrhIUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendStructuredInputRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'sendStructuredInput',
  auth: 'app',
  fingerprint: 'wFqv667kwuZb8zVFAHfceUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendToolResponseRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'sendToolResponse',
  auth: 'app',
  fingerprint: 'L0JnjrQzOVnnj8JNEEpm3UH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendToolApprovalRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'sendToolApproval',
  auth: 'app',
  fingerprint: 't-O8Ah0GzcbjlVXzgnmJOkH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const prepareLocalSendMessageRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'prepareLocalSendMessage',
  auth: 'app',
  fingerprint: 'BCxl_42erSVam2b_8OXbFUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const prepareLocalSendMessagesRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'prepareLocalSendMessages',
  auth: 'app',
  fingerprint: '2R4SlzDwQ-Vam2b_8OXbFUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const prepareLocalSendStructuredInputRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'prepareLocalSendStructuredInput',
  auth: 'app',
  fingerprint: 'wFqv667kwuZam2b_8OXbFUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const prepareLocalToolResponseRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'prepareLocalToolResponse',
  auth: 'app',
  fingerprint: 'L0JnjrQzOVmcuaNbGS7Q1EH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const prepareLocalToolApprovalRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'prepareLocalToolApproval',
  auth: 'app',
  fingerprint: 't-O8Ah0GzcbOxf20IA2xPUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelTurnRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'cancelTurn',
  auth: 'app',
  fingerprint: 'cKX0x47vNVqOUe2e_r4XmUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const steerTurnRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'steerTurn',
  auth: 'app',
  fingerprint: 'yMSKq9CAuDIDpH6CGGkGVEH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelActiveTurnRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'cancelActiveTurn',
  auth: 'app',
  fingerprint: 'lMHRg1fDZAielV2RcqPsqUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTurnResultRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'getTurnResult',
  auth: 'app',
  fingerprint: 'oWuQs4arL20I5g6e1_F2_UH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitFeedbackRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'submitFeedback',
  auth: 'app',
  fingerprint: 'jK3hNmvIzqeOUe2e_r4XmUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAblyTokenRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'getAblyToken',
  auth: 'app',
  fingerprint: 'uAbz6J0mmACO-26M1ZO-UEH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOrCreateAblyChannelRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'getOrCreateAblyChannel',
  auth: 'app',
  fingerprint: 'voOakUJYXW8h9xgYZ6Q04UH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const convertAvroSchemaToJsonSchemaRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineService',
  rpcName: 'convertAvroSchemaToJsonSchema',
  auth: 'app',
  fingerprint: 'O9DlV5No7M2on-tK3tloWUH3ubeO4YHW',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};